import React from 'react';
import Matter from 'matter-js';

export default function usePhysicsEngine(
  ref: React.RefObject<HTMLCanvasElement>
): [Matter.Engine | null, Matter.Render | null] {
  const [engine, setEngine] = React.useState<Matter.Engine | null>(
    null
  );
  const [renderer, setRenderer] =
    React.useState<Matter.Render | null>(null);

  React.useEffect(() => {
    if (!ref.current) {
      return;
    }

    // create an engine
    const engine = Matter.Engine.create();

    // create a renderer
    const renderer = Matter.Render.create({
      canvas: ref.current,
      engine,
      options: {
        width: ref.current.width,
        height: ref.current.height,
        wireframes: false,
        background: 'transparent',
      },
    });

    Matter.Runner.run(engine);
    Matter.Render.run(renderer);

    setEngine(engine);
    setRenderer(renderer);
  }, [ref]);

  return [engine, renderer];
}
